/** Название товара, когда бэк не прислал вложенный пакет. */
const FALLBACK_PRODUCT_NAME = "Пакет";
/**
 * Данные покупки по платежу.
 *
 * `transactionId` — id платежа в НАШЕЙ базе (тот же, по которому бэк шлёт
 * ecom-покупку через Measurement Protocol): один платёж — одна транзакция, как
 * бы пользователь ни вернулся с кассы.
 *
 * Цену товара берём из ФАКТИЧЕСКИ оплаченной суммы, а не из прайса пакета:
 * иначе скидка/промо разъехались бы с выручкой. Сумма приходит строкой
 * («990.00», pydantic-Decimal — см. `PaymentResponse.amount`), поэтому только
 * через Number с защитой от NaN.
 *
 * Вложенного `package` может не быть (платёж без пакета / старый бэк) — тогда
 * товар описываем тем, что есть: `package_id` и обобщённым названием.
 */
export function buildMetrikaPurchase(payment) {
    const parsed = Number(payment.amount);
    const revenue = Number.isFinite(parsed) ? parsed : 0;
    const pkg = payment.package ?? null;
    const productId = pkg?.id ?? payment.package_id;
    return {
        transactionId: String(payment.id),
        revenue,
        products: [
            {
                id: productId != null ? String(productId) : String(payment.id),
                name: pkg?.title || FALLBACK_PRODUCT_NAME,
                price: revenue,
                quantity: 1,
                // `kind` пакета (one_time / subscription / release) — чтобы в отчёте
                // электронной торговли релизы не смешивались с песенными пакетами.
                ...(pkg?.kind ? { category: pkg.kind } : {}),
            },
        ],
    };
}
